import { EMPTY, merge, Observable } from 'rxjs';

export interface Service extends ServiceLike {
  readonly changes$: Observable<void>;
  readonly effects$: Observable<void>;
}

export interface ServiceLike {
  readonly changes$?: Observable<any>;
  readonly effects$?: Observable<any>;
}

export const NULL_SERVICE: Service = {
  changes$: EMPTY,
  effects$: EMPTY,
};

export function createService(...services: ServiceLike[]) {
  return new BaseService(...services);
}

export class BaseService implements Service {
  constructor(...dependencies: ServiceLike[]) {
    this.changes$ = merge(...dependencies.map(service => service.changes$ || EMPTY));
    this.effects$ = merge(...dependencies.map(service => service.effects$ || EMPTY));
  }

  readonly changes$: Observable<void>;
  readonly effects$: Observable<void>;
}

export function isService(maybeService: any): maybeService is Service {
  return (
    maybeService &&
    typeof maybeService === 'object' &&
    'changes$' in maybeService &&
    'effects$' in maybeService
  );
}
